import { Model } from '@/services/api/lib'

export class Order extends Model {
  resource () {
    return 'orders/v1/orders'
  }

  primaryKey () {
    return 'number'
  }

  async loadComments () {
    const comments = await this.request({
      method: 'GET',
      url: `${this.endpoint()}/comments`
    }).then(response => response.data)

    this.comments = comments
  }

  async addComment (msg) {
    await this.request({
      method: 'POST',
      url: `${this.endpoint()}/comments`,
      data: {
        notify: false,
        text: msg
      }
    }).then(response => response.data)
    await this.loadComments()
  }

  async loadHoldReasons () {
    const holdReasons = await this.request({
      method: 'GET',
      url: `${this.endpoint()}/hold_reasons`
    }).then(response => response.data)

    this.holdReasons = holdReasons
  }

  get unfulfilled () {
    const items = []
    this.items.forEach(item => {
      const shipped = this.shipped.find(x => x.id === item.id)
      if (shipped) {
        items.push(Object.assign({}, item, { quantity: item.quantity - shipped.quantity }))
      } else {
        items.push(Object.assign({}, item))
      }
    })
    return items.filter(x => x.quantity)
  }

  get shipped () {
    const items = []
    this.items.forEach(item => {
      this.shipments.forEach(shipment => {
        const shipped = shipment.items.find(x => x.item_id === item.id)
        if (shipped) {
          items.push(Object.assign({}, item, { quantity: shipped.quantity }))
        }
      })
    })
    return items
  }

  get shippedui () {
    return this.shipments.map(shipment => {
      const items = shipment.items.map(item => {
        const origin = this.items.find(x => x.id === item.item_id)
        return Object.assign({}, origin, { quantity: item.quantity })
      })
      return Object.assign({}, shipment, { items })
    })
  }

  release () {
    return this.request({
      method: 'PATCH',
      url: `${this.endpoint()}/release`
    })
  }

  hold (reason) {
    return this.request({
      method: 'PATCH',
      url: `${this.endpoint()}/hold`,
      data: { reason }
    })
  }

  cancel (restock = true) {
    return this.request({
      method: 'PATCH',
      url: `${this.endpoint()}/cancel`,
      data: { restock }
    })
  }

  markAsPaid (orderNumber) {
    return this.request({
      method: 'PATCH',
      url: `${this.endpoint()}/${orderNumber}/paid`
    })
  }

  archive () {
    return this.request({
      method: 'PATCH',
      url: `${this.endpoint()}/archive`
    })
  }

  refund (order, data) {
    return this.request({
      method: 'PATCH',
      url: `${this.endpoint()}/${order.number}/refund`,
      data: data
    })
  }

  void (order, data) {
    return this.request({
      method: 'PATCH',
      url: `${this.endpoint()}/${order.number}/void`,
      data: data
    })
  }

  hasNotes (item) {
    if (!item.notes) {
      return false
    }

    let notes = item.notes
    if (!Array.isArray(notes)) {
      notes = Object.keys(notes)
    }

    return notes.length > 0
  }

  printDocument (doc, download) {
    if (!doc) {
      return
    }

    return this.request({
      method: 'POST',
      responseType: 'arraybuffer',
      url: `${this.endpoint()}/documents/${doc.id}`
    }).then(response => {
      const file = Buffer.from(response.data, 'binary')
      const url = window.URL.createObjectURL(new Blob([file], { type: 'application/pdf;base64' }))
      const link = document.createElement('a')

      const pdfName = `${doc.type}_${doc.number}.pdf`
      if (download) {
        link.setAttribute('download', pdfName)
      } else {
        link.setAttribute('print', pdfName)
      }

      link.href = url
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
    })
  }

  discountIncluded () {
    return this.tax_type === 'vat' && this.discount_after_tax && this.vat_in_price
  }

  hasPendingAuthorization () {
    return this.transactions &&
      this.transactions.length &&
      this.transactions.some(trans => trans.type === 'authorize' && trans.status === 1)
  }

  hasPaymentCaptured () {
    return this.transactions &&
      this.transactions.length &&
      this.transactions.some(trans => trans.type === 'payment' && trans.status === 2)
  }

  hasPaymentCapturedOffline () {
    return this.transactions &&
      this.transactions.length &&
      this.transactions.some(trans => trans.type === 'payment' && trans.status === 2 && trans.payment_type === 'offline')
  }
}
